import { UsersOverviewComponent } from '../users-overview.component';
import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/model/user';

@Component({
  selector: 'app-employee-users-overview',
  templateUrl: '../users-overview.component.html',
  styleUrls: ['../users-overview.component.scss']
})
export class EmployeeUsersOverviewComponent extends UsersOverviewComponent
  implements OnInit {
  ngOnInit() {
    super.ngOnInit();
    this.tableTitle = 'Werknemers';
    this.newUserLabel = 'Nieuwe werknemer';
  }

  // Override
  createUser(): void {
    this.router.navigate(['/users/employee-edit/0']);
  }

  // Override
  editRow(row: User): void {
    this.router.navigate([`/users/employee-edit/${row.id}`]);
  }

  // Override
  setDisplayColumns() {
    this.displayedColumns = [
      'firstName',
      'lastName',
      'roles',
      'email',
      'employee',
      'lastLogin',
      'star'
    ];
  }

  // Override
  protected getLocalStorageKey(): string {
    return 'EmployeeUsersOverviewComponent';
  }

  // Override
  protected getPopulateUrl(): string {
    return '/users/employees';
  }

  // Override
  protected getReturnRoute(): string {
    return '/users/employees';
  }
}
